import RpmModalSummary from "./RpmModalSummary"

export default  RpmModalSummary;



// WEBPACK FOOTER //
// ./src/components/App/ClientListWithMap/ClientDetail/QuickFocus/RpmDataModal/RpmModalSummary/index.js